export default "__VITE_ASSET__DyB8$pP8__"